module.exports = __webpack_public_path__ + "img/groups_mail_careers.f21129cc.png";